module.exports = __webpack_public_path__ + "static/media/EN new.b6524692.svg";